"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JOB_STATUS = exports.schedulePeriodValues = exports.schedulePeriod = exports.scheduleModeValues = exports.scheduleMode = exports.jobType = exports.scheduleTypeValues = exports.scheduleType = void 0;
var lodash_1 = __importDefault(require("lodash"));
exports.scheduleType = {
    EVALUATION: 'evaluation',
    PREDICTION: 'prediction',
    LEARNING: 'learning',
    INITIAL_LEARNING: 'initial-learning',
    DATAPOOL_STATISTICS: 'datapool-statistics',
};
exports.scheduleTypeValues = lodash_1.default.values(exports.scheduleType);
exports.jobType = exports.scheduleType;
exports.scheduleMode = {
    SCHEDULED: 'scheduled',
    MANUAL: 'manual',
    TRIGGER: 'trigger',
};
exports.scheduleModeValues = lodash_1.default.values(exports.scheduleMode);
exports.schedulePeriod = {
    HOURLY: 'hourly',
    DAILY: 'daily',
    WEEKLY: 'weekly',
    MONTHLY: 'monthly',
};
exports.schedulePeriodValues = lodash_1.default.values(exports.schedulePeriod);
exports.JOB_STATUS = {
    PENDING: 'pending',
    FINISHED: 'finished',
    FAILED: 'failed',
};
//# sourceMappingURL=enums.js.map